<template>
  <div>
    <van-sticky>
      <van-nav-bar title="绑定微信账户" left-arrow @click-left="goBack" />
    </van-sticky>
    <div class="page">
      <div class="explain">
        <span>为确保您顺利提现，请准确填写您的账户信息：</span>
        <div class="explain-nav">
          <p>1、绑定的微信号为提现操作发放的微信号；</p>
          <p>2、您所绑定的微信号码，本身必须绑定有银行卡；</p>
          <p>
            3、绑定微信号，务必保证输入的用户姓名与所
            绑定的微信号，钱包的银行卡账号所有人姓 名一致，否则无法提现。
          </p>
        </div>
      </div>
      <div class="explain">
        <span>关联微信账号提现方法</span>
        <div class="explain-nav">
          <p>
            1、复制下方链接或点击分享按钮，把“微信提
            现绑定”发送到你个人提现的微信号；
          </p>
          <div class="link">
            <p>{{ url }}</p>
          </div>
          <div class="button">
            <van-button size="small" @click="copy">复制链接</van-button>
            <van-button size="small" @click="share">分享到个人微信</van-button>
          </div>
          <p>
            2、 从微信中打开“微信提现绑定”链接，在展
            开的页面上输入你在平台注册的账号和密 码，点击登录；
          </p>
          <div class="img">
            <img src="@/assets/images/gold-coin/binging_login.png" alt="" />
          </div>
          <p>
            3、 普惠平台用户端注册的账号和密码登录验证
            成功后，输入当前打开的微信号，微信钱包
            里绑定的银行卡账户所有人的姓名（必须是
            真实姓名），点击“绑定”即可完成微信账 号提现账户的关联；
          </p>
          <div class="img">
            <img src="@/assets/images/gold-coin/binging_name.png" alt="" />
          </div>
        </div>
        <!-- <div class="bottom-btn">
          <van-button type="primary" block @click="goBind">开始绑定</van-button>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { FRONTEND_HOST,domainNameConstant } from '@/config/domainnameconstant'
import Cookies from 'js-cookie'

export default {
  data() {
    return {
      url: '',
    }
  },
  created() {
    const token = Cookies.get('token')
    const redirect_uri = encodeURIComponent(
      `${FRONTEND_HOST}/gold-coin/bind-name?access_token=${token}`
    )
    this.url = `https://${domainNameConstant}/ucenter/api/wx/webpage/binding?returnUrl=${redirect_uri}
`
    console.log('this.url', this.url)
  },
  methods: {
    goBack() {
      if (this.$getIsApp()) {
        this.$callApp('Android', 'GoBackAppMethod', '')
        this.$callApp('iOS', 'GoBackAppMethod', '')
      } else {
        this.$router.go(-1)
      }
    },

    copy() {
      this.$callApp('Android', 'CopyMethod', this.url)
      this.$callApp('iOS', 'CopyMethod', this.url)
    },
    share() {
      this.$callApp('Android', 'ShareTextToWechatMethod', this.url)
      this.$callApp('iOS', 'ShareTextToWechatMethod', this.url)
    },
    goBind() {
      this.$router.push({ path: '/gold-coin/bind-name' })
    },
  },
}
</script>

<style lang="less" scoped>
.page {
  padding: 10px;
  background: #f83600;
  .explain {
    margin-bottom: 8px;
    background: white;
    border-radius: 8px;
    padding: 10px 18px;
    span {
      font-size: 14px;
      font-weight: 500;
      color: #ff7b35;
    }
    .explain-nav {
      margin-top: 10px;
      height: 145;
      padding: 10px;
      background: #fff1cc;

      p {
        font-size: 14px;
        font-weight: 400;
        color: #323233;
        margin: 10px 0;
        line-height: 18px;
      }
      .link {
        word-wrap: break-word;
        padding: 10px;
        background: white;
      }
      .img {
        display: flex;
        justify-content: center;

        img {
          width: 228px;
          height: 338px;
        }
      }
      .button {
        span {
          font-size: 14px;
          font-weight: 500;
          color: #fff;
        }
        /deep/ .van-button--small {
          border-radius: 8px;
          background: #0033ff;
          color: #fff !important;
        }
        margin: 10px 0;
        justify-content: space-around;
        display: flex;
      }
    }
  }
  .bottom-btn {
    padding: 10px 0;
    /deep/.van-button--block {
      background: #e67f11;
      border-radius: 15px;
      border: none;
    }
    span {
      font-size: 14px;
      font-weight: 500;
      color: #fff;
    }
  }
}
</style>